import styled from "@emotion/styled";
import { ReactElement } from "react";
import * as React from "react";

import Block from "components/layout/Block";

interface IProps {
  thead: JSX.Element | JSX.Element[];
  tbody: JSX.Element | JSX.Element[];
  paddingBottom?: string;
  divider?: ReactElement;
  children?: React.ReactNode;
}

interface ITableProps extends IProps {
  forwardedRef: React.Ref<HTMLDivElement>;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContentContainer = styled.div`
  flex: 1;
  overflow: auto;
`;

const StyledTable = styled.table`
  table-layout: fixed;
  border-collapse: separate;
  width: 100%;
  font-size: 15px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };

  th {
    border-bottom: 1px solid
      ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.borderColor
      };
  }

  tbody tr {
    transition: background-color 0.25s;
    &:hover {
      background-color: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) => props.theme.table.highlightedRow.backgroundColor
      };
    }
  }
`;

class Table extends React.PureComponent<ITableProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { thead, tbody, forwardedRef, paddingBottom, divider } = this.props;

    return (
      <Wrapper>
        <StyledTable>{thead}</StyledTable>
        {divider}
        <ContentContainer ref={forwardedRef}>
          <StyledTable>{tbody}</StyledTable>
          {paddingBottom && <Block minHeight={paddingBottom} />}
        </ContentContainer>
      </Wrapper>
    );
  }
}

export default React.forwardRef((props: IProps, ref: React.Ref<HTMLDivElement>) => (
  <Table {...props} forwardedRef={ref} />
));
